import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const MultiplicationCards = () => {
  const colors = [
    "from-slate-600 to-slate-800",      // Perkalian 1
    "from-sky-500 to-blue-600",         // Perkalian 2
    "from-green-500 to-emerald-600",    // Perkalian 3
    "from-yellow-500 to-orange-500",    // Perkalian 4
    "from-orange-600 to-red-600",       // Perkalian 5
    "from-red-600 to-pink-600",         // Perkalian 6
    "from-slate-700 to-gray-800",       // Perkalian 7
    "from-cyan-500 to-blue-500",        // Perkalian 8
    "from-green-600 to-teal-600",       // Perkalian 9
    "from-yellow-400 to-amber-500"      // Perkalian 10
  ];

  const generateMultiplicationTable = (num: number) => {
    return Array.from({ length: 10 }, (_, i) => ({
      multiplicand: i + 1,
      multiplier: num,
      result: (i + 1) * num
    }));
  };

  return (
    <div className="py-12">
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {Array.from({ length: 10 }, (_, index) => {
          const num = index + 1;
          const table = generateMultiplicationTable(num);
          
          return (
            <Card 
              key={num}
              className={`futuristic-card bg-gradient-to-br ${colors[index]} text-white cursor-pointer`}
            >
              <CardHeader className="pb-4">
                <CardTitle className="text-4xl text-center font-bold">
                  Perkalian {num}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                {table.map((item, idx) => (
                  <div 
                    key={idx}
                    className="flex justify-between items-center text-lg font-mono hover:bg-white/10 rounded px-3 py-2 transition-colors"
                  >
                    <span className="text-xl">{item.multiplicand}×{item.multiplier}</span>
                    <span className="font-bold text-xl">= {item.result}</span>
                  </div>
                ))}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MultiplicationCards;